import React, { FunctionComponent } from 'react';
import styles from './BaseCardTextHeader.module.scss';

interface IProps {
  children: React.ReactNode;
}

const BaseCardTextHeader: FunctionComponent<IProps> = ({ children }) => (
  <div className={styles.container}>{children}</div>
);

export default BaseCardTextHeader;
